import { IRootState } from '../reducer'
import {
  prefix,
  ADD_FEEDBACK_INFO_REQUEST,
  CREATE_FEEDBACK_REQUEST,
  LIST_FEEDBACK_REQUEST,
} from './actions'

export const feedbackIsSubmitting = (state: IRootState) =>
  state[prefix].loadingArray.includes(CREATE_FEEDBACK_REQUEST)

export const feedbackIsSubmitted = (state: IRootState) => state[prefix].isSubmitted

export const feedbackSubmitError = (state: IRootState) => state[prefix].submitError

export const feedbackData = (state: IRootState) => state[prefix].data

export const feedbackIsLoading = (state: IRootState) =>
  state[prefix].loadingArray.includes(LIST_FEEDBACK_REQUEST)

export const feedbackIsAddingInfo = (state: IRootState) =>
  state[prefix].loadingArray.includes(ADD_FEEDBACK_INFO_REQUEST)

export const feedbackInfoAdded = (state: IRootState) => state[prefix].infoAdded

export const feedbackInfoError = (state: IRootState) => state[prefix].infoError

export const feedbackSubmissionsById = (state: IRootState) => state[prefix].submissionsById

export const feedbackFilesById = (state: IRootState) => state[prefix].filesById
